export default function About({ go }) {
  return (
    <div style={{ padding:'48px 1.5rem', background:'var(--warm)', minHeight:'100vh' }}>
      <style>{`
        .about-grid { display: grid; grid-template-columns: 1fr 1.4fr; gap: 4rem; align-items: start; }
        .about-sticky { position: sticky; top: 90px; }
        .creds-grid { display: grid; grid-template-columns: 1fr 1fr; gap: .75rem; margin-top: 1.5rem; }
        @media (max-width: 768px) {
          .about-grid { grid-template-columns: 1fr; gap: 2rem; }
          .about-sticky { position: static; }
          .creds-grid { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className="container">
        <div className="about-grid">

          {/* Left: sticky card */}
          <div className="about-sticky">
            <div style={{ background:'white', borderRadius:20, border:'1px solid var(--border)', padding:'1.75rem' }}>
              <div style={{ width:72, height:72, borderRadius:'50%', background:'var(--teal)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'DM Serif Display',serif", fontSize:28, color:'white', marginBottom:'1.25rem' }}>E</div>
              <h3 style={{ fontFamily:"'DM Serif Display',serif", fontSize:22, color:'var(--teal-deeper)', marginBottom:4 }}>Ebere Ann Ugwu</h3>
              <div style={{ fontSize:13, color:'var(--coral)', fontWeight:600, marginBottom:'1.25rem' }}>Founder · Tinytrust Services</div>
              <div style={{ display:'flex', flexWrap:'wrap', gap:8, marginBottom:'1.5rem' }}>
                {['CPR Level C + AED','First Aid','Background Checked','VSC Clear','7+ Years','BBA Graduate','Medication Admin'].map(b => (
                  <span key={b} className="badge" style={{ fontSize:11 }}>{b}</span>
                ))}
              </div>
              <div style={{ borderLeft:'3px solid var(--teal)', paddingLeft:'1rem', fontStyle:'italic', fontSize:13, color:'var(--text-mid)', lineHeight:1.7, marginBottom:'1.5rem' }}>
                "Every child deserves to feel safe and loved. Every family deserves a caregiver they can truly trust."
              </div>
              <div style={{ fontSize:13, color:'var(--text-light)', lineHeight:2 }}>
                <div>📍 Calgary, Alberta</div>
                <div>📧 ebereannugwu@gmail.com</div>
                <div>📞 204-510-3869</div>
                <div>🪪 Licence No: TN28080273</div>
              </div>
            </div>
          </div>

          {/* Right: content */}
          <div>
            <div className="sec-label">About the founder</div>
            <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'clamp(24px,3vw,36px)', color:'var(--teal-deeper)', marginBottom:'1.25rem', lineHeight:1.2 }}>
              Hi, I'm Ebere — and caring for children is my life's work.
            </h2>
            {[
              'I founded Tinytrust Services because I know what it feels like to truly care for a child. With over 7 years of professional experience supporting children and adults with diverse needs, I built this business on one promise: that every family who comes to us will feel completely at ease.',
              'My background spans residential support work, disability care, drug rehabilitation support, and private nannying. I have worked with children and adults living with autism, Down syndrome, FASD, dementia, and complex behavioural needs — giving me a deep understanding of how to meet each person where they are, with patience and compassion.',
              'Currently, I serve as a private nanny to a 10-year-old in Calgary — managing her full after-school routine from school pickup, homework, activities, and meals, all the way to her bedtime routine. That family\'s trust means everything to me.',
              'Every caregiver in the Tinytrust network has been personally vetted by me. I only bring on people who share my standards for safety, warmth, and professionalism. When you hire through Tinytrust, you are not just hiring a nanny — you are gaining a team that stands behind every placement.',
            ].map((p,i) => (
              <p key={i} style={{ fontSize:15, color:'var(--text-mid)', lineHeight:1.8, marginBottom:'1rem' }}>{p}</p>
            ))}

            <div className="creds-grid">
              {[
                'CPR Level C with AED ',
                'First Aid certified',
                'Criminal record check clear',
                'Child abuse registry clearance',
                'Vulnerable Sector Check clear',
                'Medication administration certified',
                'Valid Class 5 driver\'s licence',
                'Adult abuse registry clearance',
                'BBA — University of Winnipeg',
                '7+ years professional experience',
              ].map(c => (
                <div key={c} style={{ display:'flex', alignItems:'center', gap:8, fontSize:13, color:'var(--text-mid)' }}>
                  <div style={{ width:20, height:20, borderRadius:'50%', background:'var(--teal-light)', color:'var(--teal)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, flexShrink:0 }}>✓</div>
                  {c}
                </div>
              ))}
            </div>

            <div style={{ marginTop:'2rem' }}>
              <button className="btn-primary" onClick={() => go('consult')}>
                Book a free consultation with Ebere →
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}